import type { YMapsApi } from '@pbe/react-yandex-maps/typings/util/typing'
import type { PartialRecord } from 'share/types'
import type { GetCitiesResponse } from 'share/types/api/leads'

const DEFAULT_COORDS = [43.246106, 76.945298]

export type YandexMapState = {
  center?: number[]
  markerCoords?: number[]
  zoom: number
  controls: string[]
}

export const defaultMapState: YandexMapState = {
  center: DEFAULT_COORDS,
  markerCoords: DEFAULT_COORDS,
  zoom: 14,
  controls: ['zoomControl']
}

export type MapComponent = {
  kind:
    | 'house'
    | 'street'
    | 'metro'
    | 'district'
    | 'locality'
    | 'area'
    | 'province'
    | 'country'
    | 'hydro'
    | 'railway'
    | 'route'
    | 'vegetation'
    | 'airport'
    | 'аэропорт'
    | 'other'
  name: string
}

export type MapComponents = Array<MapComponent>

export type GeocodeValueReturn = ReturnType<typeof geocodeValue>

export const checkIsDeliveryAvailable = (cities: GetCitiesResponse | undefined, cityName: string | undefined) => {
  if (!cities || !cityName) return false
  return cities.findIndex(city => city.name === cityName) === -1 ? false : true
}

export const geocodeValue = async (ymaps: YMapsApi, value: string | number[], options?: ymaps.IGeocodeOptions) => {
  const response = await ymaps.geocode(value, options)
  const firstGeoObject = response.geoObjects.get(0) as any
  return {
    response,
    firstGeoObject,
    coords: firstGeoObject.geometry.getCoordinates()
  }
}

export const getAddressObject = (geoObject: any) => {
  const components: PartialRecord<MapComponent['kind'], string> = {}
  const coords = geoObject.geometry.getCoordinates()
  const geoObjectComponents = geoObject.properties.getAll().metaDataProperty.GeocoderMetaData.Address
    .Components as MapComponents
  geoObjectComponents.forEach(component => {
    components[component.kind] = component.name
  })

  return {
    components,
    coords
  }
}
